module.exports = __webpack_public_path__ + "media/images/svgs/logo-wide-36a79c093b3d9aea3ce382a89464543f.svg";